(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.mobileMenu = this.querySelector('header-drawer');
      this.currentScrollTop = 0;
      this.preventHide = false;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.enableScroll();
    }

    disconnectedCallback() {
      this.disableScroll();
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide || (this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160)) {
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventReveal) {
          return;
        }
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    enableScroll() {
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disableScroll() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-trail"] && !Shopify.designMode) return;
  try {
    
  class StarTrail {
    constructor(rootEl) {
      this.root = rootEl;
      this.canvas = rootEl.querySelector('.star-trail-section__canvas');
      this.ctx = this.canvas.getContext('2d');

      // Config da data-attribute (impostati dallo schema della sezione)
      this.color = rootEl.dataset.starColor || '#FF5F00';
      this.starSize = parseFloat(rootEl.dataset.starSize) || 100;
      this.maxStars = parseInt(rootEl.dataset.maxStars, 10) || 8;
      this.spawnDistance = parseFloat(rootEl.dataset.spawnDistance) || 40;
      this.fadeSpeed = parseFloat(rootEl.dataset.fadeSpeed) || 0.02;

      this.stars = [];
      this.lastPoint = null;
      this.rafId = null;
      this.isVisible = false;
      this.dpr = Math.min(window.devicePixelRatio || 1, 2); // cap per evitare canvas enormi su schermi ad alta densità

      // Rispetta le preferenze di accessibilità: niente JS/animazione
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.reducedMotion) return;

      // Su touch device non esiste hover: evitiamo di allocare canvas/listener inutili
      this.isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
      if (this.isTouch) return;

      this._onMouseMove = this._onMouseMove.bind(this);
      this._onMouseLeave = this._onMouseLeave.bind(this);
      this._tick = this._tick.bind(this);

      this._setupResizeObserver();
      this._bindEvents();
      this._setupIntersectionObserver();
    }

    _resizeCanvas() {
      const { width, height } = this.root.getBoundingClientRect();
      if (width === 0 || height === 0) return;

      this.canvas.width = width * this.dpr;
      this.canvas.height = height * this.dpr;
      this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    }

    _setupResizeObserver() {
      this.resizeObserver = new ResizeObserver(() => this._resizeCanvas());
      this.resizeObserver.observe(this.root);
    }

    // Anima solo quando la sezione è effettivamente visibile in viewport
    _setupIntersectionObserver() {
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.isVisible = entry.isIntersecting;
            if (this.isVisible) {
              this._startLoop();
            } else {
              this._stopLoop();
            }
          });
        },
        { threshold: 0 }
      );
      this.intersectionObserver.observe(this.root);
    }

    _bindEvents() {
      this.root.addEventListener('mousemove', this._onMouseMove);
      this.root.addEventListener('mouseleave', this._onMouseLeave);
    }

    _onMouseMove(e) {
      const rect = this.root.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      if (
        !this.lastPoint ||
        Math.hypot(x - this.lastPoint.x, y - this.lastPoint.y) > this.spawnDistance
      ) {
        this.stars.push({ x, y, life: 1 });
        if (this.stars.length > this.maxStars) {
          this.stars.shift();
        }
        this.lastPoint = { x, y };
      }
    }

    _onMouseLeave() {
      this.stars = [];
      this.lastPoint = null;
    }

    _drawStar(cx, cy, outerRadius, innerRadius, alpha) {
      const points = 9;
      const step = Math.PI / points;
      let rot = -Math.PI / 2;
      const ctx = this.ctx;

      ctx.beginPath();
      ctx.moveTo(cx + Math.cos(rot) * outerRadius, cy + Math.sin(rot) * outerRadius);

      for (let i = 0; i < points; i++) {
        rot += step;
        ctx.lineTo(cx + Math.cos(rot) * innerRadius, cy + Math.sin(rot) * innerRadius);
        rot += step;
        ctx.lineTo(cx + Math.cos(rot) * outerRadius, cy + Math.sin(rot) * outerRadius);
      }

      ctx.closePath();
      ctx.globalAlpha = alpha;
      ctx.fillStyle = this.color;
      ctx.fill();
      ctx.globalAlpha = 1;
    }

    _tick() {
      const { width, height } = this.root.getBoundingClientRect();
      this.ctx.clearRect(0, 0, width, height);

      for (let i = this.stars.length - 1; i >= 0; i--) {
        const s = this.stars[i];
        const outerRadius = (this.starSize / 2) * s.life;
        const innerRadius = outerRadius * 0.45;
        this._drawStar(s.x, s.y, outerRadius, innerRadius, s.life);
        s.life -= this.fadeSpeed;
      }

      this.stars = this.stars.filter((s) => s.life > 0);

      // Ferma il loop quando non c'è nulla da disegnare e niente in coda,
      // verrà riavviato al prossimo mousemove
      if (this.stars.length === 0) {
        this.rafId = null;
        return;
      }

      this.rafId = requestAnimationFrame(this._tick);
    }

    _startLoop() {
      this._resizeCanvas();
      if (this.rafId === null) {
        this.rafId = requestAnimationFrame(this._tick);
      }
      // Riavvia il loop anche su mousemove se era stato fermato per inattività
      this.root.addEventListener('mousemove', this._ensureLoop || (this._ensureLoop = () => {
        if (this.rafId === null && this.isVisible) {
          this.rafId = requestAnimationFrame(this._tick);
        }
      }));
    }

    _stopLoop() {
      if (this.rafId !== null) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    }

    destroy() {
      this._stopLoop();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.root.removeEventListener('mousemove', this._onMouseMove);
      this.root.removeEventListener('mouseleave', this._onMouseLeave);
      if (this._ensureLoop) {
        this.root.removeEventListener('mousemove', this._ensureLoop);
      }
    }
  }

  // Inizializzazione + supporto al Theme Editor (hot reload sezione)
  const starTrailInstances = new Map();

  function initStarTrail(container) {
    const existing = starTrailInstances.get(container);
    if (existing) existing.destroy();
    starTrailInstances.set(container, new StarTrail(container));
  }

  document.querySelectorAll('.star-trail-section').forEach(initStarTrail);

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const container = event.target.querySelector('.star-trail-section');
      if (container) initStarTrail(container);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const container = event.target.querySelector('.star-trail-section');
      const instance = starTrailInstances.get(container);
      if (instance) {
        instance.destroy();
        starTrailInstances.delete(container);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
